import React from 'react';
import { createUseStyles, useTheme } from 'react-jss';
import { useNavigate } from 'react-router-dom';
import SLUGS from '../../resources/slugs';
import {
    IconStar,
    Icondropdown,
    IconIdeas

} from '../../assets/icons';
import { Route, Routes,Navigate } from 'react-router-dom';
import { convertSlugToUrl } from '../../resources/utilities';
import LogoComponent from './LogoComponent';
import Menu from './MenuComponent';
import MenuItem from './MenuItemComponent';

const useStyles = createUseStyles({
    separator: {
        borderTop: ({ theme }) => `1px solid ${theme.color.lightGrayishBlue}`,
        marginTop: 16,
        marginBottom: 16,
    }
});
function SidebarComponent() {
    const  push  = useNavigate();
    const theme = useTheme();
    const classes = useStyles({ theme });
    const isMobile = window.innerWidth <= 1080;

    async function logout() {
        push(SLUGS.login);
    }

    function onClick(slug, parameters = {}) {
        push(convertSlugToUrl(slug, parameters));
    }

    return (
        <Menu isMobile={isMobile}>
            <div style={{ paddingTop: 30, paddingBottom: 30 }}>
                <LogoComponent />
            </div>
          
              <MenuItem
                id={SLUGS.subscription}
                title='Subscription'
                icon={IconIdeas}
                onClick={() => onClick(SLUGS.subscription)}
               
            />
              <MenuItem
                id={SLUGS.profile}
                title='Profile'
                icon={IconIdeas}
                href='/profile'
                onClick={() => onClick(SLUGS.profile)}
            />
                <MenuItem
                id={SLUGS.reports}
                title='Reports'
                icon={IconIdeas}
                href='/reports'
                onClick={() => onClick(SLUGS.reports)}
            />
        </Menu>
    );
}

export default SidebarComponent;
